import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ProductHeader from '../../components/ProductHeader/ProductHeader';
import ProductGallery from '../../components/ProductGallery/ProductGallery';
import ProductVariantSelector from '../../components/ProductVariantSelector/ProductVariantSelector';
import ProductDiscountSnippet from '../../components/ProductDiscountSnippet/ProductDiscountSnippet';
import AddToCartBtnBundle from '../../components/AddToCartBtnBundle/AddToCartBtnBundle';
import ProductAccordion from '../../components/ProductAccordion/ProductAccordion';
import KlarnaPlacement from '../../components/KlarnaPlacement/KlarnaPlacement';
import DySlider from '../../components/DySlider/DySlider';
import ProductAddOnList from '../../components/ProductAddOnList/ProductAddOnList';
import ProductAddOnModal from '../../components/ProductAddOnModal/ProductAddOnModal';
import ProductAddOnListModal from '../../components/ProductAddOnListModal/ProductAddOnListModal';
import ProductBundleSizeGuide from '../../components/ProductBundleSizeGuide/ProductBundleSizeGuide';
import ProductBundleMessage from '../../components/ProductBundleMessage/ProductBundleMessage';
import ProductBundleSlider from '../../components/ProductBundleSlider/ProductBundleSlider';

import useFetch from '../../hooks/useFetch';
import useSelectedVariant from '../../hooks/useSelectedVariant';

import { StyledWrapper, StyledGrid, DetailsGridDiv } from './BundleProductStyles';

var _ref = React.createElement(ProductBundleSizeGuide, null);

var BundleProduct = function BundleProduct(props) {
  var product = props.product;

  var variantInventoryData = useFetch('/products/' + props.product.handle + '?view=variant-inventory');

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      atcClicked = _useState2[0],
      setAtcClicked = _useState2[1];

  var _useSelectedVariant = useSelectedVariant(props.product),
      _useSelectedVariant2 = _slicedToArray(_useSelectedVariant, 3),
      selected = _useSelectedVariant2[0],
      handleOptionChange = _useSelectedVariant2[1],
      variantExists = _useSelectedVariant2[2];

  var _useState3 = useState(1),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedVariantQuantity = _useState4[0],
      setSelectedVariantQuantity = _useState4[1];

  var addOnModalTag = product.tags.find(function (tag) {
    return tag.includes('data--add_on:duvet-insert');
  });

  var addOnListTag = product.tags.find(function (tag) {
    return tag.includes('data--add_on:duvet-list');
  });

  // Keeps track of add on items (for duvet covers)

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      addOnListSelectedItems = _useState6[0],
      setAddOnListSelectedItems = _useState6[1];

  var handleSetAddOnListSelectedItems = function handleSetAddOnListSelectedItems(product) {
    var selectedItems = [].concat(_toConsumableArray(addOnListSelectedItems));
    if (selectedItems.includes(product)) {
      selectedItems = selectedItems.filter(function (currentProduct) {
        return currentProduct !== product;
      });
    } else {
      selectedItems = [].concat(_toConsumableArray(selectedItems), [product]);
    }
    setAddOnListSelectedItems(selectedItems);
  };

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      productHandleForModal = _useState8[0],
      setProductHandleForModal = _useState8[1];

  var setActiveProductForAddOnModal = function setActiveProductForAddOnModal(handle) {
    setProductHandleForModal(handle);
  };

  var handleQuantityChange = function handleQuantityChange(value) {
    setSelectedVariantQuantity(value);
  };

  // Shipping Surcharge
  // #TEMPSHIPPINGSURCHARGE (remove after setting up middleware)
  var shippingSurchargeTag = product.tags.includes('data--shipping-surcharge');

  var eligibleForDiscountSnippet = product.tags.includes('data--no_coupon:0');

  var variant_selectors = product.options.map(function (option) {
    return React.createElement(ProductVariantSelector, {
      handleOptionChange: handleOptionChange,
      key: option.id,
      option: option,
      selectedOptions: selected.options,
      variants: product.variants.edges,
      productId: product.id
    });
  });

  // PREPPING BUNDLE PRODUCTS
  var selectedSize = selected.options['Size'];
  var bundleArr = props.bundleProducts.map(function (prod) {
    var product = prod.node;
    var bundlePreferredVariant = product.tags.some(function (tag) {
      return tag.includes('bundle-preferred-variant--');
    }) ? product.tags.find(function (tag) {
      return tag.includes('bundle-preferred-variant--');
    }).replace('bundle-preferred-variant--', '') : '';

    var selectedProdVariantArr = product.variants.edges.filter(function (variant) {
      if (bundlePreferredVariant !== '') {
        return bundlePreferredVariant !== '' && selectedSize.includes(bundlePreferredVariant) && variant.node.title.replace(' ', '').split('/').some(function (size) {
          return size === bundlePreferredVariant;
        });
      } else {
        return variant.node.title.replace(' ', '') === selectedSize.replace(' ', '') || variant.node.title.includes('/') && variant.node.title.replace(' ', '').split('/').some(function (size) {
          return size === selectedSize;
        }) || selectedSize.includes('/') && selectedSize.replace(' ', '').split('/').some(function (size) {
          return size === variant.node.title;
        });
      }
    });
    var selectedProdVariant = selectedProdVariantArr.length > 0 ? selectedProdVariantArr[0] : product.variants.edges[0];
    return {
      product: product,
      selectedVariant: selectedProdVariant.node
    };
  });

  var klarnaPrice = parseFloat(selected.variant.priceV2.amount.replace('$', ''));
  return React.createElement(
    'div',
    null,
    React.createElement(
      StyledWrapper,
      null,
      React.createElement(
        StyledGrid,
        null,
        React.createElement(ProductGallery, {
          product: product,
          selectedVariant: selected.variant,
          isWishlistProduct: props.isWishlistProduct,
          toggleAccountModal: props.toggleAccountModal
        }),
        React.createElement(ProductHeader, {
          title: product.title,
          selectedVariant: selected.variant,
          nonReturnableVariant: product.tags.includes('NONRETURNABLE'),
          ineligibleForDiscount: product.tags.includes('data--no_coupon:1'),
          productListingSnippet: product.productListingSnippet,
          preorderDate: selected.variant.preorderDate,
          product: product
        }),
        React.createElement(
          DetailsGridDiv,
          null,
          props.bundleProductHandle && _ref,
          product.variants.edges.length > 1 ? variant_selectors : null,
          props.pdpDiscountSnippet.display && selected.variant.availableForSale && eligibleForDiscountSnippet && React.createElement(ProductDiscountSnippet, {
            selectedVariant: selected.variant,
            pdpDiscountSnippet: props.pdpDiscountSnippet,
            pdpCollectionDiscount: props.pdpCollectionDiscount
          }),
          addOnListTag && React.createElement(ProductAddOnList, {
            addOnListTag: addOnListTag,
            selectedOptions: selected.options,
            handleSetAddOnListSelectedItems: handleSetAddOnListSelectedItems,
            setActiveProductForAddOnModal: setActiveProductForAddOnModal
          }),
          React.createElement(AddToCartBtnBundle, {
            selectedVariantId: selected.variant.id,
            variantExists: variantExists,
            selectedVariantQuantity: selectedVariantQuantity,
            addVariantToCart: props.addVariantToCart,
            selectedVariantAvailable: selected.variant.availableForSale,
            product: product,
            btnStyle: 'PRODUCT',
            setAtcClicked: setAtcClicked,
            addOnListSelectedItems: addOnListSelectedItems,
            bundleProductHandle: props.bundleProductHandle,
            bundleProducts: bundleArr,
            shippingSurcharge: shippingSurchargeTag // #TEMPSHIPPINGSURCHARGE
            , ineligibleForDiscount: product.tags.includes('data--no_coupon:1')
          }),
          klarnaPrice > 35 && React.createElement(KlarnaPlacement, { price: klarnaPrice }),
          React.createElement(ProductAccordion, {
            tags: product.tags,
            vendor: product.vendor,
            customReturnPolicy: product.returnPolicy,
            shipLaterEnabled: props.shipLaterEnabled,
            preorderDate: selected.variant.preorderDate,
            pdpAccordionBnslCopy: props.pdpAccordionBnslCopy,
            pdpReturnCopy: props.pdpReturnCopy,
            shippingTimes: props.shippingTimes,
            material: selected.variant.material,
            dimension: selected.variant.dimension,
            product: product
          })
        )
      ),
      addOnModalTag && React.createElement(ProductAddOnModal, {
        addVariantToCart: props.addVariantToCart,
        selectedOptions: selected.options,
        checkout: props.checkout,
        atcClicked: atcClicked,
        addOnModalTag: addOnModalTag // addOnModalTag ex: data--add_on:duvet-insert
      }),
      addOnListTag && React.createElement(ProductAddOnListModal, {
        addOnClicked: productHandleForModal !== '',
        productHandle: productHandleForModal,
        setProductHandleForModal: setProductHandleForModal,
        selected: selected
      })
    ),
    React.createElement(ProductBundleMessage, {
      bundleMessage: product.bundleMessage,
      bundleHeader: product.bundleHeader
    }),
    React.createElement(
      StyledWrapper,
      null,
      React.createElement(ProductBundleSlider, { bundleProducts: bundleArr, selected: selected })
    ),
    React.createElement(
      StyledWrapper,
      null,
      React.createElement(DySlider, {
        addVariantToCart: props.addVariantToCart,
        checkout: props.checkout,
        dySlug: 'bundle-slider'
      })
    )
  );
};

BundleProduct.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  pdpDiscountSnippet: PropTypes.object.isRequired,
  isWishlistProduct: PropTypes.bool.isRequired,
  shipLaterEnabled: PropTypes.bool,
  toggleAccountModal: PropTypes.func.isRequired,
  bundleProducts: PropTypes.array,
  bundleProductHandle: PropTypes.string,
  pdpAccordionBnslCopy: PropTypes.string,
  pdpReturnCopy: PropTypes.string,
  shippingTimes: PropTypes.object,
  lowStockThreshold: PropTypes.string,
  pdpCollectionDiscount: PropTypes.object
};

export default BundleProduct;